import { h } from "preact";
import Picture from "./Picture";
import { css } from "emotion";
import HumanitixCause from "./HumanitixCause";

const eventCharity = css({
  padding: "16px 15px",
  textAlign: "center",
  border: "1px solid #DEDEDE",
  borderRadius: 4,
  color: "#323232",
  textDecoration: "none",
  display: "block",
  ":hover,:focus": {
    textDecoration: "underline",
    color: "#323232"
  },
  background:"#fff"
});

const supportingMsg = css({
  fontWeight: 600,
  fontSize: 12,
  letterSpacing: "-0.28px",
  color: "#5a626c !important",
  display: "inline-block",
  margin: "13px 0px 2px 0px",
});

const charityName = css({
  color: "#323232",
  fontSize: 16,
  letterSpacing: "-0.37px",
  fontWeight: 600,
  marginBottom: 8
});

const description = css({
  color: "#323232",
  fontSize: 14,
  letterSpacing: "-0.33px",
  textAlign: "center",
  marginBottom: 12
})

const impactMsg = css({
  marginBottom: 0,
  fontSize: 14,
  color: "#323232 !important",
  letterSpacing: "-0.58px",
  fontWeight: 600,
});

const roundImg = css({
  overflow: "hidden",
  borderRadius: 80,
  height: 80,
  width: 80
});

const imageWrapper = css({
  height: 80,
  maxWidth: 80,
  margin: "0px auto",
  padding: "0px 0px 10px 0px"
});

const EventCharity = ({ event }) => {
  if (!event || !event.showCharity) {
    return null;
  }
  if (event.isFree && !event.hasDonation) {
    return <HumanitixCause EventOrganiser={event.organiser} />;
  }
  const charity = event.charity;
  const impactString = charity.impactCreated
    ? charity.impactCreated
    : charity.oneLiner;
  return (
    <a href={charity.website} className={eventCharity}>
      <div
        className={css([
          imageWrapper,
          css({ width: charity.impactCreated ? 120 : 100 })
        ])}
      >
        {charity.impactCreated ? (
          <div className={roundImg}>
            <Picture
              alt={charity.name}
              img={charity.logo}
              width={80}
              height={80}
            />
          </div>
        ) : (
          <Picture alt={charity.name} img={charity.logo} width={100} />
        )}
      </div>
      <h3 className={supportingMsg}>Your booking fee is supporting</h3>
      <h2 className={charityName}>{charity.name}</h2>
      <p className={description}>{charity.oneLiner}</p>
      <p className={impactMsg}>{impactString}</p>
    </a>
  );
};
export default EventCharity;
